



























































































import { Component, Vue } from 'vue-property-decorator';
import { panoramicQueryServer } from '@/api/installServer';

@Component({
  components: {},
})
export default class CompanyDialog extends Vue {
  dialogVisible: any = false;
  loading: any = false;

  detailForm: any = {};

  showDialog(data: any) {
    this.dialogVisible = true;
    this.getCompanyDataById(data.id);
  }
  getCompanyDataById(id: any) {
    panoramicQueryServer
      .getSinglePerformanceData({ id: id })
      .then((res: any) => {
        if (res.code === '200') {
          this.detailForm = res.data;
        }
      })
      .catch((error: any) => {});
  }
  handleClose(done: any) {
    done();
  }
}
